import React from 'react';
import {connect} from 'react-redux';
import Breadcrumb from '../../../components/breadcrumb/index';
import Message from '../../../components/message/index';
import {Multiselect} from 'multiselect-react-dropdown';
import { updateUserDetail } from '../../../actions/actions';
const existRoles = [
    {name: 'Standart', id: 'Standart'},
    {name: 'Sales', id: 'Sales'},
    {name: 'XIPartner', id: 'XIPartner'},
    {name: 'XIVodafone', id: 'XIVodafone'},
    {name: 'XIConsultant', id: 'XIConsultant'},
    {name: 'OmsgReport', id: 'OmsgReport'},
    {name: 'XIVFAdmin', id: 'XIVFAdmin'},
]

class UserDetail extends React.Component {
    constructor(props)
    {
        super(props);
        const user = this.props.history.location.state.user;
        this.state = {
            selectedRoles: user.userRole.map(userRole => ({ name: userRole, id: userRole })),
            userName: user.userName,
            userEmail: user.userEmail,
            userLdapName: user.userLdapName
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleSubmit()
    {
       if(this.state.selectedRoles != null && this.state.selectedRoles.length > 0) {
            var requestedRoles = this.state.selectedRoles.map(selectedRole => selectedRole.name);
            updateUserDetail({
                id: this.props.history.location.state.user.userId,
                roles: requestedRoles,
                userName: this.state.userName,
                userEmail: this.state.userEmail,
                userLdapName: this.state.userLdapName
            }, (response) => {
            }, (data) => {
            });
        }
    } 

    handleInputChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    
    handleTypeOptionValueChange(selectedRoles) {
       this.setState({selectedRoles});
    }


    render() {
        const breadcrumbItems = [{
            name: 'Ana Sayfa',
            link: '/'
        },{
            name: 'Kullanıcı Listesi',
            link : '/admin/user-list'
        },{
            name: this.props.history.location.state.user.userName
        }];

        return (
        [
          <Breadcrumb items={breadcrumbItems} />,
          <section className="panel">
            <Message />
            <div className="container">
                <div className="user-detail">
                    <div className="user-group-edit">
                        <div className="form-container">
                            <div className="items">
                                <div className="item-container">
                                    <div className="item">
                                        <div>Kullanıcı Adı</div>
                                        <div className="form-item single">
                                            <input
                                                type="text"
                                                name="userName"
                                                value={this.state.userName}
                                                onChange={this.handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div>Email</div>
                                        <div className="form-item single">
                                            <input
                                                type="email"
                                                name="userEmail"
                                                value={this.state.userEmail}
                                                onChange={this.handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div>Roller</div>
                                        <Multiselect class=""
                                            onSelect={(e) => this.handleTypeOptionValueChange(e)}
                                            onRemove={(e) => this.handleTypeOptionValueChange(e)}
                                            selectedValues={this.state.selectedRoles}
                                            options={existRoles} 
                                            closeMenuOnSelect={true}

                                            placeholder={"Seçiniz"} 
                                            displayValue="name" 
                                        />
                                    </div>
                                    <div className="item">
                                        <div>LDAP Adı</div>
                                        <div className="form-item single">
                                            <input
                                                type="text"
                                                name="userLdapName"
                                                value={this.state.userLdapName}
                                                onChange={this.handleInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {this.state.selectedRoles.length > 0 && <a id="" className="btn primary user-detail-save" href="javascript:void(0)" title="Tümünü indir" onClick={this.handleSubmit.bind(this)}><span>Kaydet</span></a>}
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>
          </section>
        ]
      );
    }
  }

  function mapStateToProps(state) {
      return {
          app: state.app 
      }
  }

  export default connect(mapStateToProps)(UserDetail)